(function () {
  "use strict";

  var KEY = "sm_sale_context_v2";

  function getParamsFromSearch(search) {
    try {
      var qs = new URLSearchParams(search || "");
      var sale = (qs.get("sale") || "").toLowerCase();
      var spRaw = qs.get("sp");
      var sp = spRaw == null ? null : parseInt(spRaw, 10);
      if (sale === "holiday" && Number.isFinite(sp) && sp > 0) return { sale: sale, sp: sp };
    } catch (e) {}
    return null;
  }

  function load() {
    try {
      var raw = sessionStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function save(ctx) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(ctx));
    } catch (e) {}
  }

  function currentCtx() {
    return getParamsFromSearch(window.location.search) || load();
  }

  function shouldSkipLink(href) {
    if (!href) return true;
    if (href.indexOf("#") === 0) return true;
    if (href.indexOf("mailto:") === 0) return true;
    if (href.indexOf("tel:") === 0) return true;
    if (href.indexOf("/account") === 0) return true;
    if (href.indexOf("/cart") === 0) return true;
    if (href.indexOf("/checkout") === 0) return true;
    return false;
  }

  function decorateInternalLinks(ctx) {
    if (!ctx) return;

    var links = document.querySelectorAll('a[href^="/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute("href");
      if (shouldSkipLink(href)) continue;

      if (href.indexOf("sale=") !== -1 || href.indexOf("sp=") !== -1) continue;

      try {
        var url = new URL(href, window.location.origin);
        url.searchParams.set("sale", ctx.sale);
        url.searchParams.set("sp", String(ctx.sp));
        a.setAttribute("href", url.pathname + "?" + url.searchParams.toString() + url.hash);
      } catch (e) {}
    }
  }

  function observeDomForLinks(ctx) {
    if (!ctx || !window.MutationObserver) return;

    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        decorateInternalLinks(ctx);
      }, 200);
    });

    try {
      obs.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  function appendCtxToSectionRequest(inputUrl, ctx) {
    try {
      var url = new URL(inputUrl, window.location.origin);
      if (url.origin !== window.location.origin) return inputUrl;

      var isSectionRender = url.searchParams.has("section_id") || url.searchParams.has("sections");
      if (!isSectionRender) return inputUrl;

      if (url.searchParams.has("sale") || url.searchParams.has("sp")) return inputUrl;

      url.searchParams.set("sale", ctx.sale);
      url.searchParams.set("sp", String(ctx.sp));
      return url.toString();
    } catch (e) {
      return inputUrl;
    }
  }

  function patchFetch(ctx) {
    if (!window.fetch) return;
    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      try {
        if (typeof input === "string") {
          input = appendCtxToSectionRequest(input, ctx);
        } else if (input && input.url) {
          var newUrl = appendCtxToSectionRequest(input.url, ctx);
          if (newUrl !== input.url) input = new Request(newUrl, input);
        }
      } catch (e) {}
      return originalFetch.call(this, input, init);
    };
  }

  function patchXHR(ctx) {
    if (!window.XMLHttpRequest) return;
    var open = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        url = appendCtxToSectionRequest(url, ctx);
      } catch (e) {}

      var args = Array.prototype.slice.call(arguments);
      args[1] = url;
      return open.apply(this, args);
    };
  }

  // Boot
  var fromUrl = getParamsFromSearch(window.location.search);
  if (fromUrl) save(fromUrl);

  var ctx = currentCtx();
  if (!ctx) return;

  patchFetch(ctx);
  patchXHR(ctx);

  var path = window.location.pathname.replace(/\/+$/, "");
  if (path.endsWith("/pages/holiday-sale")) {
    decorateInternalLinks(ctx);
    observeDomForLinks(ctx);
  }

  // --- Keep sale/sp in the URL on PDP (so Liquid/sections renders keep working) ---
(function keepPdpParamsInUrl() {
  try {
    if (!location.pathname.includes("/products/")) return;

    var url = new URL(location.href);
    var hasSale = (url.searchParams.get("sale") || "").toLowerCase() === ctx.sale;
    var hasSp = url.searchParams.get("sp") === String(ctx.sp);

    if (!hasSale) url.searchParams.set("sale", ctx.sale);
    if (!hasSp) url.searchParams.set("sp", String(ctx.sp));

    if (!hasSale || !hasSp) {
      history.replaceState({}, "", url.pathname + "?" + url.searchParams.toString() + url.hash);
    }
  } catch (e) {}
})();

})();
